import axios from "axios";

export const TEACHER_URL = "/Teacher";
export const STUDENT_URL = "/Student";
export const ACTIVITY_REPORT_URL = "/ActivityReport";

/** Mevcut Okulun Belli Bir Dönemdeki Belli Bir Faaliyet Raporunu Elde Eder */
export function getActivityReport(queryParams) {
  return axios.post(`${ACTIVITY_REPORT_URL}/GetActivityReport`, queryParams);
}

/** Mevcut Okulun Belli Bir Dönemdeki Belli Bir Faaliyet Raporunu Sayfalama Olmadan Elde Eder */
export function getAllActivityReport(queryParams) {
  return axios.post(`${ACTIVITY_REPORT_URL}/GetAllActivityReport`, queryParams);
}

/**  Mevcut Okulun Mevcut Dönemdeki Şube, Öğretmen ve Faaliyet Türü Listesini Elde Eder */
export function getList() {
  return axios.get(`${ACTIVITY_REPORT_URL}/GetList`);
}

/** Mevcut Okula Ait Belli Bir Dönemde Sözleşmesi Olan Öğretmen Listesini Elde Eder */
export function getTeachers(term) {
  return axios.get(`${TEACHER_URL}/GetTeachers/${term}`);
}

/** Mevcut Okula Ait Bir Dönemde Belli Bir Sınıftaki Öğrenci Listesini Elde Eder */
export function getStudents(term, sectionId) {
  return axios.get(`${STUDENT_URL}/GetStudentsInSection/${term}/${sectionId}`);
}

/** Belli Bir Faaliyetin Ekini İndirir */
export function downloadAttachment(id) {
  return axios.get(`${ACTIVITY_REPORT_URL}/DownloadAttachment/${id}`, { responseType: "blob" });
}

/** Belli Bir Faaliyetin Açıklamasını Elde Eder */
export function getExplanation(activityId) {
  return axios.get(`${ACTIVITY_REPORT_URL}/GetExplanation/${activityId}`);
}